import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { PUBLIC_RARITIES } from '@anidex/shared/economy';
import { AnimaIcon, FragmentIcon } from '../components/Brand';
import { PublicHeader } from '../components/PublicHeader';
import { SiteFooter } from '../components/SiteFooter';
import { BoosterPack } from '../features/gacha/BoosterPack';
import { boosterName } from '../i18n/catalog';
import { rarityLabel } from '../services/format';
import { CollectionIcon, SocialIcon } from '../components/Icons';

export function LandingPage() {
  const { t } = useTranslation('pages');
  return (
    <>
      <PublicHeader />
      <main className="landing" id="contenu" tabIndex={-1}>
        <section className="landing__hero">
          <div className="landing__copy">
            <h1>{t('landing.title')}</h1>
            <p>{t('landing.intro')}</p>
            <div className="landing__actions">
              <Link to="/inscription" className="button button--primary button--large">
                {t('landing.start')}
              </Link>
              <Link to="/regles" className="button button--large">
                {t('landing.seeRules')}
              </Link>
            </div>
            <p className="landing__note">{t('landing.free')}</p>
          </div>
          <div className="landing__stage scene night" aria-hidden="true">
            <span className="landing__stage-caption">{t('landing.nextDraw')}</span>
            <div className="landing__packs">
              <span className="landing__pack landing__pack--left">
                <BoosterPack type="standard" name={boosterName('standard', 'Booster Standard')} size="lg" />
              </span>
              <span className="landing__pack landing__pack--right">
                <BoosterPack type="premium" name={boosterName('premium', 'Booster Premium')} size="lg" />
              </span>
              <span className="landing__pack landing__pack--center">
                <BoosterPack type="legendary" name={boosterName('legendary', 'Booster Chanceux')} size="lg" />
              </span>
            </div>
          </div>
        </section>

        <section className="landing__features" aria-label={t('landing.experience')}>
          <div><CollectionIcon size={22} /><span>{t('landing.album')}</span></div>
          <div><SocialIcon size={22} /><span>{t('landing.community')}</span></div>
        </section>

        <section className="landing__section" aria-labelledby="rarity-title">
          <h2 id="rarity-title">{t('landing.raritiesTitle')}</h2>
          <ul className="rarity-ladder">
            {PUBLIC_RARITIES.map((rarity) => (
              <li key={rarity} className={`rarity-ladder__step rarity-${rarity}`}>
                <span className="rarity-ladder__card" aria-hidden="true" />
                <span>{rarityLabel(rarity)}</span>
              </li>
            ))}
          </ul>
        </section>

        <section className="landing__section" aria-labelledby="loop-title">
          <h2 id="loop-title">{t('landing.howTitle')}</h2>
          <ol className="loop">
            <li>
              <span className="loop__icon">
                <AnimaIcon size={36} />
              </span>
              <h3>{t('landing.openTitle')}</h3>
              <p>{t('landing.openText', { rare: rarityLabel('rare') })}</p>
            </li>
            <li>
              <span className="loop__icon">
                <FragmentIcon size={36} />
              </span>
              <h3>{t('landing.duplicatesTitle')}</h3>
              <p>{t('landing.duplicatesText', { common: rarityLabel('common'), divine: rarityLabel('divine') })}</p>
            </li>
            <li>
              <span className="loop__icon">
                <span className="loop__level" aria-hidden="true">
                  5
                </span>
              </span>
              <h3>{t('landing.upgradeTitle')}</h3>
              <p>{t('landing.upgradeText')}</p>
            </li>
          </ol>
        </section>
        <section className="landing__invite">
          <h2>{t('landing.invite')}</h2>
          <Link to="/inscription" className="button button--primary">{t('landing.start')}</Link>
        </section>
        <SiteFooter />
      </main>
    </>
  );
}
